import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import InventoryLogsCreateui from "./InventoryLogsCreateui";
import { closeModal } from "../../store/actions/modalAction";
import {
  LOG_TYPE,
  MATERIAL_TYPE,
  SNACK_BAR_VARIETNS,
} from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import moment from "moment";
import {
  CreateInventoryLogsApi,
  FetchMaterialRequestByRequestIdApi,
  FetchQrApi,
  FetchQrByIdApi,
  UpadteInventoryIQCApi,
  FetchProductionPurchaseRequestByRequestIdApi,
} from "../../apis/inventoryLogs.api";
import { fetchRawMaterialApi } from "../../apis/rawMaterial.api";
import { FetchSKDApi } from "../../apis/skd.api";
import { FetchSFGApi } from "../../apis/sfg.api";
import { FetchFGApi } from "../../apis/FG.api";

const InventoryLogsCreateController = ({ id, callBack = () => {} }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [QrId, SetQrId] = useState("");
  const QrLoading = useRef(false);
  const [fields, setFields] = useState({
    err: "",
    date: moment().toISOString(),
    materialType: "",
    materialId: "",
    quantity: "",
    amount: "",
    invoiceNumber: "",
    vendorId: "",
    logType: LOG_TYPE.In,
    itemCode: "",
    pricePerUnits: "",
    requestCreatedBy: "",
    orderedQuantity: "",
    iqc: {
      quantity: 0,
      accepted: 0,
      reworkable: 0,
      rejected: 0,
      date: moment(),
    },
  });
  console.log("fields", fields);
  const [originalDocument, setOriginalDocument] = useState({});

  const checkHIDDevice = useCallback(async () => {
    try {
      if (!navigator.hid) {
        throw new Error("WebHID API is not supported in this browser.");
      }
      const connectedDevices = await navigator.hid.getDevices();

      console.log("HID Devices:", connectedDevices);

      if (connectedDevices.length === 0) {
        throw new Error("Please connect Scanner Device.");
      }
    } catch (error) {
      console.error(error.message);
      dispatch(callSnackBar(error.message, SNACK_BAR_VARIETNS.info));
    }
  }, [dispatch]);
  useEffect(() => {
    if (!id || !/^[0-9a-fA-F]{24}$/.test(id)) {
      checkHIDDevice();
    }
  }, [id, checkHIDDevice]);

  const validationSchemaForCreate = useMemo(
    () => [
      {
        required: true,
        value: !!fields.date,
        field: "Date",
      },
      {
        required: true,
        value:
          fields.materialType !== null &&
          fields.materialType !== undefined &&
          fields.materialType !== "",
        field: "Material Type",
      },
      {
        required: true,
        value: !!fields.materialId,
        field: "Material Name",
      },
      {
        required: true,
        value: !!fields.logType,
        field: "Log Type",
      },
      {
        required: true,
        value: !!fields.quantity,
        field: "Quantity",
      },
      {
        required: true,
        value: !!fields.itemCode,
        field: "Item Code",
      },
      {
        required: fields?.materialType !== MATERIAL_TYPE.FG,
        value: !!fields.vendorId,
        field: "Vendor",
      },
    ],
    [fields],
  );

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.date,
        field: "Date",
      },

      {
        required: true,
        value: fields.materialType,
        field: "Material Type",
      },

      {
        required: true,
        value: fields.materialId,
        field: "Material Name",
      },

      {
        required: true,
        value: fields.logType,
        field: "Log Type",
      },

      {
        required: true,
        value: fields.quantity,
        field: "Quantity",
      },

      // {
      //     required: true,
      //     value: fields?.iqc?.accepted !== null && fields?.iqc?.accepted >= 0,
      //     field: 'Non Negative Accepted Quantity*',
      // },
      // {
      //     required: true,
      //     value: fields?.iqc?.rejected !== null && fields?.iqc?.rejected >= 0,
      //     field: 'Non Negative Rejected Quantity',
      // },
      {
        required: true,
        value: fields.location,
        field: "Location",
      },
    ],
    [fields],
  );

  const createFunction = async () => {
    console.log("Fields before validation:", fields);
    console.log("Material Type value:", fields.materialType);
    console.log("Material Type type:", typeof fields.materialType);

    const validationResponse = validate(validationSchemaForCreate);

    console.log("Validation response:", validationResponse);
    if (validationResponse === true) {
      if (QrLoading.current === true) {
        setLoading(true);
        const isObjectId = /^[0-9a-fA-F]{24}$/.test(QrId);
        dispatch(
          callApiAction(
            async () =>
              await CreateInventoryLogsApi({
                ...fields,
                vendorId: fields?.vendorId?._id
                  ? fields?.vendorId?._id
                  : fields?.vendorId,
                materialId: fields?.materialId?._id
                  ? fields?.materialId?._id
                  : fields?.materialId,
                ...(isObjectId && { qrId: QrId }),
              }),
            async (response) => {
              callBack(response);
              setLoading(false);
              dispatch(
                callSnackBar(
                  "Inventory Updated Successfully",
                  SNACK_BAR_VARIETNS.suceess,
                ),
              );
              dispatch(closeModal("inventoryLog"));
            },
            (err) => {
              setLoading(false);
              setFields({ ...fields, err });

              dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
            },
          ),
        );
      }
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const updateFunction = async () => {
    const validationResponse = validate(validationSchemaForUpdate);
    const updatedData = { id };

    for (let field in originalDocument) {
      if (
        originalDocument[field] &&
        fields[field] &&
        fields[field] !== originalDocument[field]
      ) {
        updatedData[field] = fields[field];
      }
    }

    if (validationResponse === true) {
      setLoading(true);
      const normalizedLocation = fields?.location?._id
        ? fields.location._id
        : fields?.location;
      const normalizedProductSubCategory = fields?.productSubCategoryId?._id
        ? fields.productSubCategoryId._id
        : fields?.productSubCategoryId;

      dispatch(
        callApiAction(
          async () =>
            await UpadteInventoryIQCApi({
              ...fields,
              _id: id,
              materialId: fields?.materialId?._id
                ? fields?.materialId?._id
                : fields?.materialId,
              vendorId: fields?.vendorId?._id
                ? fields?.vendorId?._id
                : fields?.vendorId,
              iqc: {
                ...fields.iqc,
                accepted: Number(fields?.iqc?.accepted) || 0,
                reworkable: Number(fields?.iqc?.reworkable) || 0,
                rejected: Number(fields?.iqc?.rejected) || 0,
                quantity: fields.quantity,
              },
              location: normalizedLocation,
              productSubCategoryId: normalizedProductSubCategory,
            }),
          async (response) => {
            callBack();
            setLoading(false);
            dispatch(
              callSnackBar(
                "Updated Finished Good Successfully",
                SNACK_BAR_VARIETNS.suceess,
              ),
            );
            dispatch(closeModal("update"));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          },
        ),
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const fetchById = useCallback(
    (id) => {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await FetchQrByIdApi({ id }),
          async (response) => {
            setFields((prevFields) => ({
              ...prevFields,
              ...response,
              iqc: {
                ...prevFields.iqc,
                ...response?.iqc,
                accepted: Number(response?.iqc?.accepted || 0),
                reworkable: Number(response?.iqc?.reworkable || 0),
                rejected: Number(response?.iqc?.rejected || 0),
              },
            }));
            setOriginalDocument(response);
            setLoading(false);
          },
          (err) => {
            setFields((prevFields) => ({ ...prevFields, err }));
            setLoading(false);
          },
        ),
      );
    },
    [dispatch],
  );

  const onSubmit = (e) => {
    e.preventDefault();

    if (QrLoading.current) {
      if (id) {
        updateFunction();
      } else {
        createFunction();
      }
    } else if (QrId.trim() === "") {
      setFields((prevFields) => ({
        ...prevFields,
        err: "Please enter a valid QR Code ID or Request ID",
      }));
    }
  };
  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  const fetchList = useCallback(() => {
    setLoading(true);

    // Check if QrId is in ObjectId format
    const isObjectId = /^[0-9a-fA-F]{24}$/.test(QrId);
    const isPRPrefix = QrId.startsWith("PR");

    dispatch(
      callApiAction(
        async () => {
          if (isObjectId) {
            return await FetchQrApi({ id: QrId });
          } else if (isPRPrefix) {
            return await FetchProductionPurchaseRequestByRequestIdApi({
              requestId: QrId,
            });
          } else {
            return await FetchMaterialRequestByRequestIdApi({
              requestId: QrId,
            });
          }
        },
        (response) => {
          console.log("API Response:", response);

          if (response) {
            if (isObjectId) {
              setFields(response);
              setLoading(false);
              QrLoading.current = true;
            } else {
              if (Array.isArray(response) && response.length > 0) {
                const materialRequest = response[0];
                console.log("Material Request:", materialRequest);

                setFields((prevFields) => ({
                  ...prevFields,
                  requestId: QrId,
                  date: materialRequest.date,
                  materialId: materialRequest.materialDetails?._id,
                  materialType: materialRequest?.materialType,
                  quantity: materialRequest?.quantity,
                  requestCreatedBy: materialRequest.requestCreatedBy?.name,

                  materialIds: materialRequest?.materialDetails,

                  materialName: materialRequest.materialDetails?.name,

                  itemCode: materialRequest.materialDetails?.itemCode || "",
                  err: "",
                }));
                setLoading(false);
                QrLoading.current = true;
              } else {
                console.log("No data in response:", response);
                setFields((prevFields) => ({
                  ...prevFields,
                  err: "No material request found",
                }));
                setLoading(false);
              }
            }
          } else {
            console.log("No response received");
            setFields((prevFields) => ({
              ...prevFields,
              err: "Data Not Found",
            }));
            setLoading(false);
          }
        },
        (err) => {
          console.error("API Error:", err);
          setFields((prevFields) => ({ ...prevFields, err: "Data Not Found" }));
          setLoading(false);
        },
      ),
    );
  }, [dispatch, QrId]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (QrId) {
        fetchList();
      }
    }, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [QrId, fetchList]);

  const APICall = (type, changedVal) => {
    switch (type) {
      case MATERIAL_TYPE.RAW_MATERIALS:
        return {
          api: fetchRawMaterialApi,
          label: "Select Raw Material",
          code: changedVal?.rawMaterial_code,
        };
      case MATERIAL_TYPE.SKD:
        return {
          api: FetchSKDApi,
          label: "Select Semi Knock Down",
          code: changedVal?.skd_Code,
        };
      case MATERIAL_TYPE.SFG:
        return {
          api: FetchSFGApi,
          label: "Select Semi Finished Good",
          code: changedVal?.sfg_Code,
        };
      case MATERIAL_TYPE.FG:
        return {
          api: FetchFGApi,
          label: "Select Finished Good",
          code: changedVal?.fg_Code,
        };
      default:
        return null;
    }
  };

  return (
    <InventoryLogsCreateui
      onSubmit={onSubmit}
      loading={loading}
      fields={fields}
      setFields={setFields}
      SetQrId={SetQrId}
      QrId={QrId}
      setLoading={setLoading}
      QrLoading={QrLoading}
      id={id}
      validationSchemaForCreate={validationSchemaForCreate}
      APICall={APICall}
    />
  );
};

export default InventoryLogsCreateController;
